import { Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { useParams } from 'react-router-dom';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { withPermission } from '../../withPermission';
import { EditorBreadcrumbs } from '../../navbar/EditorBreadcrumbs';
import {
  courseHasPendingTranslation,
  TRANSLATION_POLL_INTERVAL_MS,
} from '../../components/translations/coverageStatus';
import { TranslationCoverageView } from '../../Courses/CourseTranslationCoverage';

// The unit-level coverage page: the same view the course coverage page renders,
// fed from listByUnit. A unit is course-agnostic, so its coverage is measured
// against every translatable language (listByUnit's supportedLanguages).
export const UnitTranslationCoverage = withPermission('canManageCourseContent', () => {
  const { unitId } = useParams();
  if (unitId === null || unitId === undefined) {
    throw new Error('unitId is required');
  }

  const { data: unit } = trpcAdmin.unitsOfCompetency.byId.useQuery(unitId);
  const query = trpcAdmin.contentTranslations.listByUnit.useQuery(
    { unitId },
    {
      refetchInterval: (query) =>
        courseHasPendingTranslation(query.state.data?.units) || query.state.status === 'error'
          ? TRANSLATION_POLL_INTERVAL_MS
          : false,
    },
  );

  const unitCrumbLabel = [unit?.code, unit?.title].filter(Boolean).join(' ');

  return (
    <TranslationCoverageView
      scope="unit"
      scopeId={unitId}
      data={query.data}
      isLoading={query.isLoading}
      isError={query.isError}
      onRefetch={() => void query.refetch()}
      csvFilename={`unit-${unitId}-translation-coverage.csv`}
      breadcrumbs={
        <EditorBreadcrumbs
          crumbs={[
            { label: t`Units`, to: '/units' },
            { label: unitCrumbLabel || t`Unit`, to: `/units/${unitId}` },
          ]}
          current={
            <Text fontSize="sm" fontWeight="medium" whiteSpace="nowrap">
              <Trans>Translations</Trans>
            </Text>
          }
        />
      }
    />
  );
});
